import { LOCALE } from "core/interfaces";

import type { KindTrimmed } from "~/common/interfaces/kind-trimmed";

export const getKindPathMapping = (
	locale: LOCALE,
	kinds: KindTrimmed[] = []
) => {
	const mapping: Record<string, string> = {};

	kinds.forEach((kind) => {
		const defaultTranslation = kind.translations?.find(
			translation => translation.locale === LOCALE.ENGLISH
		);
		const translation = kind.translations?.find(
			translation => translation.locale === locale
		);

		const key = defaultTranslation?.namePlural.toLowerCase() || "key";
		const value = translation?.namePlural.toLowerCase() || "value";

		mapping[key] = value;
	});

	return mapping;
};
